import { Contact } from '../Types/types'

export type ContactsState = {
  contactList: Contact[]
  loading: boolean
}

const initialState = {
  contactList: [],
  loading: true
}

export default initialState
